// 直播畫面比例 + 數位變焦控制列（APP#9）。純展示元件:狀態與夾制在
// liveZoom.ts / DeviceLivePage，本元件只渲染按鈕並回呼。
import { useTranslation } from 'react-i18next';
import { MAX_ZOOM, MIN_ZOOM, type FitMode } from './liveZoom';
import './liveZoom.css';

export function LiveZoomControls({
  zoom,
  fit,
  onZoomIn,
  onZoomOut,
  onReset,
  onToggleFit,
}: {
  zoom: number;
  fit: FitMode;
  onZoomIn: () => void;
  onZoomOut: () => void;
  onReset: () => void;
  onToggleFit: () => void;
}) {
  const { t } = useTranslation();
  const atMin = zoom <= MIN_ZOOM;
  const atMax = zoom >= MAX_ZOOM;
  return (
    <div className="lv-zoom" role="group" aria-label={t('devices.zoomGroupLabel')}>
      <button
        className="btn-ghost lv-zoom-fit"
        data-testid="live-fit-toggle"
        onClick={onToggleFit}
        aria-pressed={fit === 'cover'}
        title={fit === 'cover' ? t('devices.fitCoverTitle') : t('devices.fitContainTitle')}
      >
        {fit === 'cover' ? t('devices.fitCoverLabel') : t('devices.fitContainLabel')}
      </button>
      <button className="btn-ghost lv-zoom-btn" data-testid="live-zoom-out" onClick={onZoomOut} disabled={atMin} aria-label={t('devices.zoomOut')}>
        −
      </button>
      <span className="lv-zoom-level" data-testid="live-zoom-level" aria-live="polite">
        {zoom.toFixed(1)}×
      </span>
      <button className="btn-ghost lv-zoom-btn" data-testid="live-zoom-in" onClick={onZoomIn} disabled={atMax} aria-label={t('devices.zoomIn')}>
        ＋
      </button>
      <button className="btn-ghost lv-zoom-reset" data-testid="live-zoom-reset" onClick={onReset} disabled={atMin}>
        {t('devices.zoomReset')}
      </button>
    </div>
  );
}
